import styled from "@emotion/styled";
import Fab from "@mui/material/Fab";

export const RightFloatingFab = styled(Fab)({
  position: "fixed",
  right: "2.5%",
  bottom: "8px",
});
